uniform sampler2D uMask;
uniform sampler2D uBackground;
uniform sampler2D uShadow;
uniform bool uIsProductOnFloor;
uniform bool uIsProductOnWall;

varying vec2 vPosition;
varying vec2 vUv;

void main() {
    vec4 shadow = texture2D(uShadow, vUv);
    vec4 background = texture2D(uBackground, vUv);
    float floorAlpha = texture2D(uMask, vUv).g;
    float wallAlpha = texture2D(uMask, vUv).b;
    vec4 floorVec = floorAlpha * shadow;
    vec4 wallVec = wallAlpha * shadow;
    if (uIsProductOnFloor == true) {
        gl_FragColor = background * (1.0 - floorAlpha);
    } else if(uIsProductOnWall == true) {
        gl_FragColor = background * (1.0 - wallAlpha);
    } else {
        gl_FragColor = background;
    }

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}